(function()
{
    //Import classes
    var BaseState = include('springroll.easeljs.BaseState'),
        DragManager = include('springroll.DragManager'),
        StoneManager = include('sortingBox.StoneManager'),
        ListTask = include('springroll.ListTask'),
        Animator = include('springroll.Animator'),
        AssetManager = include('springroll.easeljs.AssetManager'),
        Sound = include('springroll.Sound'),
        Stone = include('sortingBox.Stone'),
        Tween = include('createjs.Tween'),
        DwellTimer = include('springroll.easeljs.DwellTimer'),
        BitmapMovieClip = include('createjs.BitmapMovieClip'),
        Debug = include('springroll.Debug', false);

    var stoneManagerInstance = new StoneManager();
    StoneManager = StoneManager.prototype;

    var TRANSITION_TIME =  1.00;
    var nbWin_PER_LEVEL =  [1, 1, 1];
    var NB_FAIL_TO_LEVEL_UP =  [3, 3, -1];
    var NB_STONES =  [6,8,10];
    var BOXES_SMALL =  [
                [
                    'boxcase11_small',
                    'boxcase12_small',
                    'boxcase13_small'
                ], [
                    'boxcase21_small',
                    'boxcase22_small',
                    'boxcase23_small'
                ]
            ];
    var BOXES_BIG =  [
                [
                    'boxcase11',
                    'boxcase12',
                    'boxcase13',
                    'boxcase14'
                ], [
                    'boxcase21',
                    'boxcase22',
                    'boxcase23',
                    'boxcase24'
                ], [
                    'boxcase31',
                    'boxcase32',
                    'boxcase33',
                    'boxcase34'
                ]
            ];


    var CRITERIA_PER_DIFFCULTY =  [
                [
                    [StoneManager.CRITERIA_COLOR, 2],
                    [StoneManager.CRITERIA_SHAPE, 0],
                    [StoneManager.CRITERIA_TYPE, 0]
                ],[
                    [StoneManager.CRITERIA_COLOR, 6],
                    [StoneManager.CRITERIA_SHAPE, 0],
                    [StoneManager.CRITERIA_TYPE, 0]
                ],[
                    [StoneManager.CRITERIA_COLOR, 6],
                    [StoneManager.CRITERIA_SHAPE, 0],
                    [StoneManager.CRITERIA_TYPE, 0]
                ]
            ];
        
    var NB_STONES_PER_LINE =  [3,4,4];
    var NB_STONES_PER_ROW =  [2,3,3];
    var NB_INTRUDERS  = [0,0,3];
    var nbWin  = 0;
    var currentDifficulty  = 0;
    var goodSpeechPlayed = false;
    var currentBoxes;
    var currentRow  = 0;
    var currentLine  = 0;
    var boxcases;
    var stones; 
    var sortingCriteria; 
    var sortingCriteriaArg;
    var stoneInBox  = 0;
    var nbrStones  =0;
    var boxToRemove;
    var possibleCriteria;
    var stoneMcs = [];
    var stoneClass;
    var stoneMc;
    var jazz;

    /**
     *  Saved access to the Progress Tracker
     *  @param {springroll.easeljs.ProgressTracker} tracker
     */
    var _learning;


    var _panel;

    /**
     *  The logic for the title state
     *  @class sid.TitleState
     *  @extends springroll.easeljs.BaseState
     */
    var GameState = function(options)
    {
        BaseState.call(this, new sid.GamePanel(), options);
        _learning = this.game.learning;
        _panel = this.panel;

        this.dm = new DragManager(this.game.display.stage,this.onDragStart.bind(this),this.onDragStop.bind(this));
        this.onPlayHint = this.onPlayHint.bind(this);
    };

    //Super prototype
    var s = BaseState.prototype;

    //Extend the base state
    var p = extend(GameState, BaseState);

    /**
     *  Add custom tasks to the list of preload tasks
     *  @param {array} tasks The list of task to preload
     */
    p.addTasks = function(tasks)
    {
        var spritesNeeded = this.config.spriteManifests.game;
        var path = 'assets/images/sprites/full/';
        for (var i = 0; i < spritesNeeded.length; i++) 
        {    
            var label = spritesNeeded[i].id;
            AssetManager.loadBitmapMovieClip(
                label, 
                path, 
                this.onBMCLoaded.bind(this, label), 
                tasks
            );
        }
    };
    
    /**
    * @param {String} label 
    */
    p.onBMCLoaded = function(label)
    {
        // create new BMC using assets loaded by the springroll.easeljs.AssetManager
        var sprite = new BitmapMovieClip(
            AssetManager.getAtlas(label),
            AssetManager.getBitmapMovieClipConfig(label)
        );

        sprite.gotoAndStop(0);
        // converts the label name to camelcase and 
        // creates a reference for the sprite on the panel 
        label = label.charAt(0).toLowerCase() + label.slice(1);
        this.panel[label] = sprite;
    };

    /**
     *
     */
    p.enterDone = function()
    {
        //currentDifficulty += 1;
        //smartLeveling.saveLevel("EX2GA2", currentDifficulty);
        _learning = this.game.learning;
        
        this.panel.May.on("click",this.onMayClick.bind(this));
        this.panel.replayButton.on("click",this.startOver.bind(this));
        this.game.container.on('playHelp', this.onPlayHint);
        this.game.hints.func(this.onMayClick.bind(this));
        this.game.hints.enabled = false;

        stoneManagerInstance.panel = this.panel;
        this.completeHandler();
        
       // this.game.media.playCorrectFeedback(this.panel.May.May,(["FINAL1","FINAL2","FINAL3"][0]),this.win.bind(this));
        DwellTimer.create(this.panel.May);
    };

    p.onPlayHint = function()
    {
        this.game.learning.clickHelp(
            this.fetchColumnInfo(),
            stones.map(mapStoneProperties)
        );
    }; 

    p.onAssetsLoaded = function()
    {
        jazz = this.panel.scalingContainer;
        this.panel.assemble(this.config.spriteManifests.game);
    };

    /**
     *  When the state exists
     */
    p.exit = function()
    {
        if (!this.assetsLoaded)
            return;

        this.game.container.off('playHelp', this.onPlayHint);

        s.exit.call(this);
    };

    p.completeHandler = function()
    {
        
        inactivity.callback = this.playRowInstruction.bind(this);
        inactivity.reset(false);
        
        boxToRemove = [];
        currentDifficulty = smartLeveling.getSavedLevel("EX2GA2");
        this.initGame();
    };
    
    p.initGame = function()
    {
       this.panel.smallBox.gotoAndStop('idle');
       this.panel.bigBox.gotoAndStop('idle');

        //play the Exhibit2 music
        //SoundManager.getInstance().playSound('E2_BG_MUSIC', GameGlobalVars.E2_BG_MUSIC_VOLUME, 0, 99999);
        
        this.generateWorld();
        this.playIntro();
    };
    
    
    p.playIntro = function()
    {
        this.game.hints.enabled = false;
        this.panel.May.mouseEnabled = false;
        this.game.media.playInstruction(this.panel.May.May,'INSTRREMINDER', this.playIntroComplete.bind(this));
    };

    p.playIntroComplete = function()
    {
        createjs.Tween.get(this.game).wait(2000).call(this.playRowInstruction.bind(this));
    };

     p.generateWorld = function()
    {
        var i, j, nbGoodSorting = 0;

        if (NB_STONES_PER_LINE[currentDifficulty] == 3)
        {
            currentBoxes = BOXES_SMALL;
            this.panel.positionBoxes(true);
        } else {
            currentBoxes = BOXES_BIG;
            this.panel.positionBoxes(false);
        }
        
        smartLeveling.reset( (currentBoxes.length * (currentBoxes[0]).length) / NB_FAIL_TO_LEVEL_UP[currentDifficulty]);
        
        boxcases = [];

        currentBoxes.forEach(this.createBoxLine,this);

        while (nbGoodSorting < NB_STONES_PER_LINE[currentDifficulty])
        {
            stones = [];
            possibleCriteria = [];
            for (i=0; i<NB_STONES_PER_LINE[currentDifficulty] ;i++) //for each box line
            {
                CRITERIA_PER_DIFFCULTY[currentDifficulty].forEach(assignDifficulty);
            }

            sortingCriteria = [];
            sortingCriteriaArg = [];
            var criteriaIndex;
            for (i=0; i<NB_STONES_PER_LINE[currentDifficulty] ;i++) //for each box line
            {
                criteriaIndex = Math.floor(Math.random()*possibleCriteria.length);//NumberUtil.randomInt(0, possibleCriteria.length);
                sortingCriteria.push(possibleCriteria[criteriaIndex]);
                sortingCriteriaArg.push(getArgFromCriteria(possibleCriteria[criteriaIndex], sortingCriteriaArg));
                possibleCriteria.splice(criteriaIndex, 1);
                
            }


            var stonesTmp;
            var ignoreCriteria;
            var ignoreArgs;
            i=0;
            nbGoodSorting = 0;
            while(i < NB_STONES_PER_LINE[currentDifficulty])
            {
                ignoreCriteria = [];
                ignoreArgs = [];
                for (j=0; j<3 ;j++)
                {
                    if (i != j)
                    {
                        ignoreCriteria.push(sortingCriteria[j]);
                        ignoreArgs.push(sortingCriteriaArg[j]);
                    }
                }
                stonesTmp = stoneManagerInstance.get(
                        NB_STONES_PER_ROW[currentDifficulty],
                        sortingCriteria[i],
                        sortingCriteriaArg[i],
                        null, false,
                        ignoreCriteria,
                        ignoreArgs);
                if (stonesTmp && stonesTmp.length == NB_STONES_PER_ROW[currentDifficulty])
                {
                    stones = stones.concat(stonesTmp);
                    nbGoodSorting++;
                }
                i++;
            }
        }


        // Add intruders to stones
        stones = stones.concat(stoneManagerInstance.get(
            NB_INTRUDERS[currentDifficulty],
            -1,
            null,
            null,
            false,
            sortingCriteria,
            sortingCriteriaArg)
        );
        
        // Shuffle stones array
        for (i=0; i<stones.length ;i++)
        {
            stones.push(stones.splice(Math.floor(Math.random()*stones.length), 1)[0]);
        }


        if (NB_STONES_PER_LINE[currentDifficulty] == 3)
        {
            this.panel.smallBox.visible = true;
            this.panel.bigBox.visible = false;
            this.panel.smallBox.gotoAndStop('row_1');
        } else {
            this.panel.smallBox.visible = false;
            this.panel.bigBox.visible = true;
            this.panel.bigBox.gotoAndStop('row_1');
        }

        this.panel.removeLabels();
        this.panel.addLabels(sortingCriteriaArg);
        
        stoneMcs = [];
        stones.forEach(this.configureStone,this);

        var table = this.panel.table.getBounds();
        for(var g= 0; g< stones.length; g++)
        {
            stones[g].movieClip.visible = true;
            stones[g].movieClip.x =  (g *(900 /  stones.length)) + (this.panel.smallBox.visible ? 100 : 72);
            stones[g].movieClip.y =  this.panel.table.y + (table.height/4);
            stones[g].movieClip.originX = stones[g].movieClip.x;
            stones[g].movieClip.originY = stones[g].movieClip.y;
            stones[g].movieClip.position = g;
            stones[g].movieClip.mouseEnabled = true;
            stones[g].movieClip.mouseChildren = false;
            stones[g].movieClip.on("mouseover",this.onStoneHover.bind(stones[g].movieClip));
            stones[g].movieClip.on("mouseout",this.onStoneHover.bind(stones[g].movieClip));
        }
        
        //choose the good label
        
        var box;
        if (NB_STONES_PER_LINE[currentDifficulty] == 3)
        {
            box = jazz.smallBox;
        } else {
            box = jazz.bigBox;
        }

        _learning.startTimer('level');
        _learning.startLevel(sortingCriteriaArg.map(mapColors),this.panel.smallBox.visible ? 2 : 3,this.panel.smallBox.visible ? 3 : 4, stones.map(mapStoneProperties));
   
        _learning.startTimer('round');
        _learning.startRound(sortingCriteriaArg[0],sortingCriteriaArg.map(mapColors),this.panel.smallBox.visible ? 2 : 3, stones.map(mapStoneProperties));
    };

    p.onStoneHover = function(event)
    {
        this.gotoAndStop(event.type == "mouseover" ? "over":"out");
    };

    p.createBoxLine = function(boxLine)
    {
        boxLine.forEach(this.createBoxKey,this);
    };

    p.createBoxKey = function(boxKey)
    {
        var boxTmp;
        boxTmp = jazz.getChildByName(boxKey);
        boxTmp.visible = true;
        boxcases.push(boxTmp);
    };

    p.configureStone = function(stone)
    {
        stoneMc = this.placeStone(stone.movieClip, stoneMcs, 'table');
        stoneMc.buttonMode = true;
        stone.movieClip = stoneMc;
        stone.movieClip.stone = stone;
        this.dm.addObject(stoneMc);
        stoneMc.enableDrag();
        stoneMc.name = stone.name + stone.properties[0];
        this.panel.scalingContainer.addChild(stoneMc);
        stoneMcs.push(stoneMc);
        DwellTimer.create(stoneMc);
    };

    p.playRowInstruction = function()
    {
        var key;
        switch (sortingCriteriaArg[currentRow])
        {
            case Stone.prototype.COLOR_YELLOW:
                key = 'STATEMENT03';
                break;
            case Stone.prototype.COLOR_RED:
                key = 'STATEMENT04';
                break;
            case Stone.prototype.COLOR_BLUE:
                key = 'STATEMENT05';
                break;
            case Stone.prototype.COLOR_GREEN:
                key = 'STATEMENT06';
                break;
            case Stone.prototype.COLOR_WHITE:
                key = 'STATEMENT07';
                break;
            case Stone.prototype.COLOR_PURPLE:
                key = 'STATEMENT09';
                break;
        }
        this.panel.May.mouseEnabled = false;
        this.game.media.playInstruction(this.panel.May.May,key,this.idle.bind(this));
        inactivity.reset(true);
    };

    p.idle = function()
    {
        this.game.hints._playing = false;
        this.game.hints.enabled = true;
        this.game.hints.startTimer(12000);
        this.panel.May.mouseEnabled = true;
        Animator.play(this.panel.May.May,"idle");
    };

    p.placeStone = function(stoneMc, stones, surfaceName)
    {
        if(!stoneMc) return stoneMc;
        stoneMc.width = 52;
        stoneMc.scaleY =stoneMc.scaleX;
        
        stoneInBox = 0;

        var surface = jazz.getChildByName(surfaceName);
        if (!surface)
        {
            return null;
        }
        else
        {
            return stoneMc;
        }
    };

    p.onMayClick = function()
    {
        this.game.hints.enabled = false;
        this.game.media.playInstruction(this.panel.May.May, {"anim": "HELP", "audio": "HELP"},this.idle.bind(this));
    };

    p.onDragStart = function(stone)
    {
        stone.parent.addChild(stone);
        inactivity.reset(true);
        this.game.hints.resetTimer();
        Sound.instance.play("SmoothButtonA");
        Sound.instance.play("SmoothButtonAB");
        _learning.startTimer('drag');
        stone.stone.pickedUp = true;
        _learning.startDrag(
            stone.stone.properties[0],
            stone.stone.properties[5],
            stone.position+1,
            stones.map(mapStoneProperties),
            this.game.normalizePosition(stone.x,stone.y)
        );
    };

    p.onDragStop = function(stone)
    {
        stone.stone.pickedUp = false;
        var returned = false;
        var rowIndex = -1;
        var lineIndex = -1;
        var container = this.panel.smallBox.visible ? this.panel.smallBox : this.panel.bigBox;
        var box = this.panel.scalingContainer.getChildByName("boxcase" + (currentLine + 1) + (currentRow + 1) + (this.panel.smallBox.visible?"_small":"") );
        var boxes = (this.panel.smallBox.visible ? this.panel.smallBoxes : this.panel.bigBoxes).filter(filterBoxes);
        Sound.instance.play("SmoothButtonB");
        Sound.instance.play("SmoothButtonAB");
        var time = _learning.stopTimer('drag');

        var inside = checkIntersection({x:stone.x,y:stone.y,width:stone.width,height:stone.width},(this.panel.smallBox.visible ? this.panel.smallBoxes : this.panel.bigBoxes));

        this.game.hints.resetTimer();
        
        for (var i=0; i<currentBoxes.length ;i++)
        {
            for (var j=0; j<(currentBoxes[i]).length ;j++)
            {
                if (box.name == currentBoxes[i][j])
                {
                    rowIndex = j;
                    lineIndex = i;
                    break;
                }
                    
            }
            if (rowIndex != -1 && lineIndex != -1)
            {
                break;
            }
        }

         if (lineIndex >= 0 && currentRow == rowIndex)
            {
                var intersects = checkIntersection({x:stone.x,y:stone.y,width:stone.width,height:stone.width},boxes);
                var small = this.panel.smallBox.visible;

                if (isStoneInGoodBox(stone) && intersects)
                {
                    inactivity.reset(true);
                    stone.stone.used = true;
                    _learning.selectAnswer(stone.stone.properties[0],stone.stone.properties[5], 
                        small ? (2 - lineIndex) : (3 - lineIndex),
                        rowIndex + 1, stone.stone.properties[0], rowIndex + 1, true, this.game.normalizePosition(stone.x,stone.y),
                        stones.map(mapStoneProperties).filter(filterDroppedStones),
                        time);
                    
                    stone.buttonMode = false;
                    stone.mouseEnabled = false;
                    stone.gotoAndStop("out");
                    putStoneInBox(stone, jazz.getChildByName(currentBoxes[currentLine][currentRow]));
                    smartLeveling.incrementGood();
                    Sound.instance.play("POSITIVE_SFX");
                    
                    currentLine += 1;
                    if (currentLine >= NB_STONES_PER_ROW[currentDifficulty])
                    {
                        currentRow += 1;
                        currentLine = 0;
                        
                        if((currentRow) < NB_STONES_PER_LINE[currentDifficulty])
                        {
                            if (NB_STONES_PER_LINE[currentDifficulty] == 3)
                            {
                                this.panel.smallBox.gotoAndStop('row_' + (currentRow+1));
                            } else {
                                this.panel.bigBox.gotoAndStop('row_' + (currentRow+1));
                            }
                        }
                        
                        if (currentRow >= NB_STONES_PER_LINE[currentDifficulty])
                        {
                            this.panel.May.mouseEnabled = false;
                            this.game.hints.enabled = false;
                            if(nbWin<2)
                            {
                                if (!goodSpeechPlayed&& (currentDifficulty == 1 || Math.floor(Math.random()*2)))
                                {
                                    this.game.media.playCorrectFeedback(this.panel.May.May,(["RIGHTANSWER1","RIGHTANSWER2"])[Math.round(Math.random())], function(){
                                        this.game.media.playCorrectFeedback(this.panel.May.May,(["FINAL1","FINAL2","FINAL3"][Math.floor(Math.random() * 3)]),this.win.bind(this));
                                    }.bind(this));
                                    goodSpeechPlayed= true;
                                    
                                } else {

                                    this.game.media.playCorrectFeedback(this.panel.May.May,(["RIGHTANSWER1","RIGHTANSWER2"])[Math.round(Math.random())], function(){
                                        this.game.media.playCorrectFeedback(this.panel.May.May,(["FINAL1","FINAL2","FINAL3"][Math.floor(Math.random() * 3)]),this.win.bind(this));
                                    }.bind(this));
                                }
                                //createjs.Tween.get(this.game).wait(7500).call(this.win.bind(this));
                                _learning.endRound(_learning.stopTimer('round'), smartLeveling.roundWrong);
                                _learning.endLevel(_learning.stopTimer('level'), smartLeveling.wrong);
                            }
                            else
                            {
                                this.panel.scalingContainer.addChild(this.panel.May);//put May on top
                                this.game.media.playCorrectFeedback(this.panel.May.May,"RIGHTANSWER3", function(){
                                        this.game.media.playCorrectFeedback(this.panel.May.May,"RIGHTANSWER",this.restart.bind(this));
                                    }.bind(this));
                                createjs.Tween.get(this.game).wait(7500).call(this.win.bind(this));
                                _learning.endRound(_learning.stopTimer('round'), smartLeveling.roundWrong);
                                _learning.endLevel(_learning.stopTimer('level'), smartLeveling.wrong);
                            }
                        } else {
                            this.panel.May.mouseEnabled = false;
                            this.game.hints.enabled = false;

                            _learning.endRound(_learning.stopTimer('round'), smartLeveling.roundWrong);
                            

                            _learning.startTimer('round');
                            smartLeveling.roundWrong = smartLeveling.roundGood = 0;
                            _learning.startRound(sortingCriteriaArg[currentRow],sortingCriteriaArg.map(mapColors),this.panel.smallBox.visible ? 2 : 3, stones.map(mapStoneProperties));
                            this.playRowInstruction();
                        }
                    }
                    
                    returned = true; // Don't move back the stone to the original place
                    stoneInBox += 1;
                } else {
                    
                    if(inside)
                    {
                       this.panel.May.mouseEnabled = false;
                       this.game.hints.enabled = false;
                       smartLeveling.incrementWrong();
                       this.game.media.playIncorrectFeedback(this.panel.May.May,'WRONGANSWER',this.idle.bind(this)); 
                       Sound.instance.play("NEGATIVE_SFX");
                    }
                    else
                    {
                        _learning.endDragOutside(stone.stone.properties[0],stone.stone.properties[5],this.game.normalizePosition(stone.x,stone.y),
                        checkIntersection({x:stone.x,y:stone.y,width:stone.width,height:stone.width},[{x:this.panel.table.x,y:this.panel.table.y,width:this.panel.table.getBounds().width,height:this.panel.table.getBounds().height}]) ? "bin":"space",stones.map(mapStoneProperties),time);
                    }

                    stone.x = stone.originX;
                    stone.y = stone.originY;
                    
                }
            } else {
                stone.x = stone.originX;
                stone.y = stone.originY;
                smartLeveling.incrementWrong();
                this.panel.May.mouseEnabled = false;
                this.game.hints.enabled = false;
                Sound.instance.play("NEGATIVE_SFX");
                this.game.media.playIncorrectFeedback(this.panel.May.May,'WRONGANSWER',this.idle.bind(this));
            }
            return returned;
     };

        p.win = function()
        {
            this.game.hints.enabled = false;
            this.game.hints.stopTimer();

            if (smartLeveling.canLevelUp() && currentDifficulty < 2)
            {
                boxToRemove.length = 0;
                inactivity.reset(false);
                currentDifficulty += 1;
                smartLeveling.saveLevel("EX2GA2", currentDifficulty);
            }
            nbWin += 1;
            
            if (nbWin < 3)
            {
                inactivity.reset(true);
                this.replay();
            }
        };

        p.startOver = function()
        {
            smartLeveling.reset();
            currentDifficulty = smartLeveling.getSavedLevel("EX2GA2");
            inactivity.reset(false);
            inactivity.resetMaxTime();
            boxToRemove = [];
            this.panel.replayButton.visible = false;

            nbWin  = 0;
            currentDifficulty  = 0;
            goodSpeechPlayed = false;
            currentRow  = 0;
            currentLine  = 0;
            stoneInBox  = 0;
            nbrStones  =0;
            stoneMcs = [];

            this.initGame();
            
        };

        p.restart = function()
        {
            for(var i = 0, count = stones.length; i <  count; i++)
            {
                var stone = stones[i];
                stone.movieClip.visible = false;
            }

            this.panel.replayButton.visible = true;
            this.game.hints.resetTimer();
        };
        
        p.replay = function()
        {
            this.unload();
            this.generateWorld();
            this.playRowInstruction();
        };
        
        p.unload = function()
        {
            currentRow = 0;
            currentLine = 0;
            
            //remove old stones movieclip
            stones.forEach(function(stone){
                stone.movieClip.parent.removeChild(stone.movieClip);
            });
        };
        
        function hideAllBoxes()
        {
            BOXES_SMALL.concat(BOXES_BIG).forEach(function(boxLine){
                boxLine.forEach(function(boxKey){
                    jazz.getChildByName(boxKey).visible = false;
                });
            });
        }

        function filterBoxes(element)
        { 
            var row = isNaN(this) ? currentRow : this;
            return (element.col -1) == row;
        }

        function mapStoneProperties(element)
        {
            if(!element.color) element.color = element.properties[0];
            var trackElement = {color: element.properties[0],type: element.properties[1] + " " + element.properties[5]};
            if(element.used || element.pickedUp) 
            {
                trackElement.color = "none";
                trackElement.type = "none";
            }
            return trackElement;
        }

        function mapColors(element)
        {
            return element;
            //return Stone.prototype.COLORS.indexOf(element);
        }
        function mapColorsAndRows(element)
        {

        }
        function filterDroppedStones(element)
        {
            if(element.color == "none") return false;
            return true;
        }

        function checkIntersection(rect1,rects) 
        {
            var intersects = false;
            rects.forEach(function(rect2){
                if(!( rect1.x >= rect2.x + rect2.width || rect1.x + rect1.width <= rect2.x || rect1.y >= rect2.y + rect2.height || rect1.y + rect1.height <= rect2.y )) intersects = true;   
            });

            return intersects;
        }

        function assignDifficulty(criteriaArr)
        {
            if (criteriaArr[1] > 0) 
            {
                possibleCriteria.push(criteriaArr[0]);
            }
        }
        
        function stopEffectRocks(e)
        {
            for(var g= 0; g< this.stones.length; g++)
            {
                stones[g].movieClip.gotoAndStop("out");
            }
            
            jazz.btnEventHandler(e);
        }
        
        function getArgFromCriteria(criteria, exclude)
        {
            var arg;
            var possibilies;
            var index;


            switch (criteria) {
                case StoneManager.CRITERIA_COLOR:
                    possibilies = StoneManager.COLORS.concat();
                    break;
                case StoneManager.CRITERIA_SHAPE:
                    possibilies = StoneManager.SHAPES.concat();
                    break;
                case StoneManager.CRITERIA_TYPE:
                    possibilies = StoneManager.TYPES.concat();
                    break;
            }
            
            if (exclude === null)
            {
                index = Math.floor(Math.random()*possibilies.length);
                arg = possibilies[index];
            }
            else
            {
                while ((!arg || exclude.indexOf(arg) >= 0) && possibilies.length > 0)
                {
                    index = Math.floor(Math.random()*possibilies.length);//NumberUtil.randomInt(0, possibilies.length);
                    arg = possibilies[index];
                    possibilies.splice(index, 1);
                }
            }
            
            return arg;
        }
        
        function isStoneInGoodBox(droppedStoneMc)
        {
            var returned = false;
            var droppedStone;
            
            for (var i=0; i<stones.length ;i++)
            {
                if (stones[i] == droppedStoneMc.stone)
                {
                    droppedStone = stones[i];
                    break;
                }
            }

            if (droppedStone)
            {
                if (stoneManagerInstance.match(droppedStone, sortingCriteria[currentRow], sortingCriteriaArg[currentRow]))
                {
                    returned = true;
                } 
            }
            
            return returned;
        }

        p.fetchColumnInfo = function()
        {
            var data = [];
            
            for(var i = 0, count = sortingCriteriaArg.length; i < count; i++)
            {
                var color = sortingCriteriaArg[i];
                var info = {color:color,rows:[]};
                info.rows = (this.panel.smallBox.visible ? this.panel.smallBoxes : this.panel.bigBoxes).filter(filterBoxes,i).map(mapBoxState);
                data.push(info);
            }
            return data;
        };

        function mapBoxState(element)
        {
            if(element.used) return true;
            return false;
        }
        
        function putStoneInBox(droppedStoneMc, box)
        {
            droppedStoneMc.x = box.x + 50;
            droppedStoneMc.y = box.y + 50;
            
            box.used = true;
            box.holding = droppedStoneMc;
            boxToRemove.push(box);
            droppedStoneMc.disableDrag();
        }
        
        function trace(){for(var i = 0, count = arguments.length; i < count; i++){if(console) console.log(arguments[i]);}}

    //Assign to namespace
    namespace('sid').GameState = GameState;
}());
